<template>
	<div class="friend-request" ref="reqTabs">
		<el-tabs type="card">
			<el-tab-pane :label="'收到的申请(' + recvRequests.length + ')'">
				<el-scrollbar v-if="recvRequests.length" class="request-list" :style="tabPaneStyle">
					<div class="request-item" v-for="request in recvRequests" :key="request.id">
						<friend-request-item :request="request"></friend-request-item>
					</div>
				</el-scrollbar>
				<no-data-tip v-else class="no-data-tip" :style="tabPaneStyle"></no-data-tip>
			</el-tab-pane>
			<el-tab-pane :label="'发起的申请(' + sendRequests.length + ')'">
				<el-scrollbar v-if="sendRequests.length" class="request-list" :style="tabPaneStyle">
					<div class="request-item" v-for="request in sendRequests" :key="request.id">
						<friend-request-item :request="request"></friend-request-item>
					</div>
				</el-scrollbar>
				<no-data-tip v-else class="no-data-tip" :style="tabPaneStyle"></no-data-tip>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
import NoDataTip from '../common/NoDataTip.vue'
import FriendRequestItem from './FriendRequestItem.vue'

export default {
	name: "friendRequest",
	components: { NoDataTip, FriendRequestItem },
	data() {
		return {
			tabPaneHeight: 600
		}
	},
	computed: {
		mine() {
			return this.userStore.userInfo;
		},
		recvRequests() {
			let requests = this.friendStore.requests;
			return requests.filter((req) => this.isMine(req.recvId));
		},
		sendRequests() {
			let requests = this.friendStore.requests;
			return requests.filter((req) => this.isMine(req.sendId));
		},
		tabPaneStyle() {
			return `height:${this.tabPaneHeight}px`;
		}
	},
	methods: {
		isMine(accountId) {
			return [this.mine.id, this.mine.accountId, this.mine.imAccid].filter(Boolean).some(id => String(id) === String(accountId));
		}
	},
	mounted() {
		this.tabPaneHeight = this.$refs.reqTabs.offsetHeight - 80;
	}
}
</script>

<style scoped lang="scss">
.friend-request {
	display: flex;
	flex-direction: column;

	.tabs {
		flex: 1;
	}
}
</style>
